import { render, staticRenderFns } from "./bracket_elimination.vue?vue&type=template&id=b728e9ae"
import script from "./bracket_elimination.vue?vue&type=script&lang=js"
export * from "./bracket_elimination.vue?vue&type=script&lang=js"
import style0 from "./bracket_elimination.vue?vue&type=style&index=0&id=b728e9ae&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports